"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const main_service_1 = require("../../../main/main.service");
const material_1 = require("@angular/material");
const BaseComponent_1 = require("../../BaseComponent");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const app_service_1 = require("../../app.service");
const vasat_1 = require("vasat");
const tree_events_1 = require("@src/app/v2/commons/files/tree-events");
const map_service_1 = require("../../map.service");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const map_viewer_service_1 = require("@src/app/service/map-viewer.service");
const Cesium = window.Cesium;
var buildLayerNode = (builder, pair) => {
    var s = builder.fromStaticInfo(pair.layer.label, pair.layer.subLayers ? pair.layer.subLayers.map(element => buildLayerNode(builder, { meta: pair.meta, layer: element })) : [], false);
    s.ref = pair;
    s.selectable = pair.layer.id != "null" && pair.layer.id != "!" && pair.layer.id != "?";
    return s;
};
const ɵ0 = buildLayerNode;
exports.ɵ0 = ɵ0;
class FolderLayerNode extends tree_events_1.FolderFileNode {
    loadChildren() {
        this.initChildListener();
        this._subs.push(this._builder.streams.fileEvents.pipe(operators_1.filter(f => f.item.folder.id == this.f.id && this.hasChildren)).subscribe(f => {
            if (f.event == 'ADD') {
                console.log('## ADD CHILDREN', f, f.item);
                this.children.add(this._builder.fromFile(f.item));
            }
            else if (f.event == 'REMOVE') {
                this.children.values = this.children.values.filter(c => c.ref != f.item);
            }
        }));
        var folders = this.f.vasat.searchByObject(_4d_mapper_1.Folder)
            .equals('parent', this.f.id)
            .equals('active', true)
            .useCache(true)
            .sortBy('name')
            .queryObservable().pipe(operators_1.map(r => r.items.map(i => {
            var v = new FolderLayerNode(i, false, this.selectableFiles);
            v._builder = this._builder;
            return v;
        })));
        var files = this.f.vasat.searchByObject(_4d_mapper_1.Dataset)
            .equals("folder", this.f.id)
            .equals("active", true)
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(operators_1.map(r => {
            var res = [];
            r.items.filter(i => i['meta']).map(i => {
                var fakeLayer = {
                    label: i.name,
                    id: '?',
                    subLayers: i['meta'].layers
                };
                res.push(buildLayerNode(this._builder, { meta: i['meta'], layer: fakeLayer }));
            });
            return res;
        }));
        return rxjs_1.combineLatest([folders, files]).pipe(operators_1.map(([folderRes, fileRes]) => folderRes.concat(fileRes))).pipe(operators_1.map(r => this.children.values = r));
    }
}
class UploadWMSComponent extends BaseComponent_1.BaseComponent {
    constructor(dialogRef, mainService, route, router, fourD, snackBar, dialog, builder, mapService, cesiumMapService, service) {
        super(router, snackBar, dialog);
        this.dialogRef = dialogRef;
        this.mainService = mainService;
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.builder = builder;
        this.mapService = mapService;
        this.cesiumMapService = cesiumMapService;
        this.service = service;
        this.exampleUrls = [
            { label: 'WMS', url: 'https://services.ga.gov.au/gis/services/Bathymetry_Topography/MapServer/WMSServer?request=GetCapabilities&service=WMS' }
        ];
        this.itemsStore = new vasat_1.ArrayStore(tree_events_1.TreeEvent);
        // meta is the metadata object itself; it could be currentItem (as above), or a meta sub-object of a Dataset
        this.meta = null;
        this.selectedItems = new Set();
        this.showImport = false;
        this.showAdvanced = false;
        this.showPreviewMap = false;
        this.selectedNodeId = null;
        this.showDebug = false;
        this.reset();
        var pubFolderIds = Object.keys(service.permissions.can_i['library']).filter(k => service.permissions.can_i['library'][k] && k.startsWith('see_public_')).map(k => k.substring(11));
        //const these = ['public_australia','s_a37f609f-381c-4761-96eb-bb387a8edb5e'].join('|');
        const these = pubFolderIds.join('|');
        let theseFolders = [];
        var f = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('uid', these).queryObservable().subscribe(r => {
            if (r.items.length) {
                r.items.forEach(item => {
                    let tmp = new FolderLayerNode(item, true, true);
                    tmp['_builder'] = this.builder;
                    this.itemsStore.add(tmp);
                });
            }
        });
    }
    ngOnInit() {
    }
    reset() {
        this.selectedItems = new Set();
        //this.urlRequest = {url:"https://services.ga.gov.au/gis/services/AMSIS_Offshore_Minerals_Legacy/MapServer/WMSServer?request=GetCapabilities&service=WMS"}
        this.urlRequest = { url: "" };
    }
    requestUrl() {
        this.loading = true;
        this.service.apiDetectWmsUrl(this.urlRequest).subscribe(resA => {
            this.loading = false;
            resA.forEach(res => {
                if (res.layers.length == 1)
                    this.itemsStore.add(buildLayerNode(this.builder, { meta: res, layer: res.layers[0] }));
                else
                    this.itemsStore.add(buildLayerNode(this.builder, { meta: res, layer: {
                            id: '?',
                            label: res.label,
                            subLayers: res.layers
                        } }));
            });
        }, err => {
            this.loading = false;
            this.openSnackBarError(err.message);
        });
    }
    download() {
        // TODO: For now just use the selected scene fodler
        if (this.mapService.scene && this.mapService.scene.folder) {
            var m = new Map();
            this.selectedItems.forEach(a => {
                var existing = m.get(a.meta);
                if (existing)
                    existing.push(a.layer.id);
                else {
                    m.set(a.meta, [a.layer.id]);
                }
            });
            // console.log(m)
            var obs = [];
            m.forEach((v, k) => {
                // when the type is a reference, this isnt actually a remote streaming URL, its a local 4D resource
                // the 'id' is jsut the transfrom ID so add it to the scene like an old fashioned layer
                if (k.urlMethod == 'reference')
                    obs.push(this.mapService.scene.addChildren([new _4d_mapper_1.Transform(this.service.V).set({ id: parseInt(k.id) })]));
                // oftherwise its a streaming URL
                else
                    obs.push(this.service.apiCreateWmsLayers(this.mapService.scene.folder, { layerIds: v, meta: k }));
            });
            rxjs_1.forkJoin(obs).subscribe(res => {
                console.log("ENTER download res ", res);
                this.openSnackBarSuccess("Success");
                this.dialogRef.close();
            }, err => {
                console.log("ENTER download err ", err);
                this.openSnackBarSuccess("Error");
            });
        }
    }
    addClass(id, classy = 'selected') {
        let el = document.getElementById(id);
        if (el) {
            el.classList.add(classy);
        }
    }
    removeClass(id, classy = 'selected') {
        let el = document.getElementById(id);
        if (el) {
            el.classList.remove(classy);
        }
    }
    updateSelectedNode(incomingId = null) {
        if (this.selectedNodeId) {
            this.removeClass(this.selectedNodeId);
        }
        if (incomingId) {
            this.selectedNodeId = incomingId;
            this.addClass(this.selectedNodeId);
        }
    }
    selectExample(url = '') {
        /* let el = <HTMLInputElement>document.getElementById('fdm-import-url');
        if ( el ) {
          el.value = url;
          el.focus();
        } */
        this.urlRequest.url = url;
    }
    onChange(event) {
        console.log('## onChange [' + event.event + ']', event);
        if (event.event == "selected") {
            this.currentItem = event.item.ref;
            this.meta = null;
            let ref = event.item.ref;
            if (ref) {
                if (ref['layer']) {
                    if (ref['layer']['id']) {
                        this.updateSelectedNode('file-' + ref['layer']['id']);
                    }
                    this.meta = ref['layer'];
                    if (this.meta['bounds']) {
                        let b = this.meta['bounds'];
                        this.showPreviewMap = true;
                        setTimeout(() => {
                            let test = this.cesiumMapService.getMap('mini');
                            console.log('## onChange PREVIEW', test);
                            if (test && test.viewer) {
                                let el = document.getElementById('previewMap');
                                let f = null;
                                if (el) {
                                    f = el.querySelector('.cesium-viewer-cesiumWidgetContainer');
                                    if (f) {
                                        f['style'].height = '200px';
                                    }
                                }
                                console.log('## onChange PREVIEW EL', el, f);
                                test.viewer.entities.removeAll();
                                var bounds = test.viewer.entities.add({
                                    name: "Bounds preview",
                                    rectangle: {
                                        coordinates: Cesium.Rectangle.fromDegrees(b.minX, b.minY, b.maxX, b.maxY),
                                        material: Cesium.Color.YELLOW.withAlpha(0.3),
                                    },
                                });
                                // dont fly the map if all the bounds are zero
                                if (!(!b.minX && !b.minY && !b.maxX && !b.maxY))
                                    test.viewer.flyTo(bounds, { duration: 1 });
                                test.viewer.scene.screenSpaceCameraController.enableRotate = false;
                                test.viewer.scene.screenSpaceCameraController.enableTranslate = false;
                                test.viewer.scene.screenSpaceCameraController.enableZoom = false;
                                test.viewer.scene.screenSpaceCameraController.enableTilt = false;
                                test.viewer.scene.screenSpaceCameraController.enableLook = false;
                            }
                        }, 300);
                    }
                    else {
                        this.showPreviewMap = false;
                    }
                    console.log('## onChange LAYER', this.selectedNodeId, ref['layer']);
                }
                else {
                    console.log('## onChange OTHER', event);
                }
            }
            else {
                console.log('## onChange NO_REF', event.item);
            }
        }
        else if (event.event == "checked") {
            // If checked add it to the list
            if (event.args) {
                this.selectedItems.add(event.item.ref);
            }
            else {
                // If unchecked remove it from list
                this.selectedItems.delete(event.item.ref);
            }
        }
    }
    toggleShowImport() {
        this.showImport = !this.showImport;
    }
    toggleShowAdvanced() {
        this.showAdvanced = !this.showAdvanced;
    }
    toggleDebug() {
        this.showDebug = !this.showDebug;
        console.log('#toggle_debug', this.showDebug);
    }
}
exports.UploadWMSComponent = UploadWMSComponent;
